import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { __rest as t } from "../../_virtual/_tslib.js";
import { jsx as i } from "react/jsx-runtime";
import { createElement as o } from "react";
import n from "styled-components";
import { calculateRem as e } from "@vds-core/utilities";
import { Fonts as r } from "../../fonts/index.js";
var l = n(function (i) {
    var n = i.fontSize,
      e = i.fontWeight,
      r = i.lineheight,
      l = i.fontFamily,
      c = i.letterSpacing,
      f = i.colorConfig,
      a = i.color,
      s = i.bold,
      u = i.strikethrough,
      d = i.fontsconfig,
      m = i.primitive,
      h = i.children,
      p = t(i, ["fontSize", "fontWeight", "lineheight", "fontFamily", "letterSpacing", "colorConfig", "color", "bold", "strikethrough", "fontsconfig", "primitive", "children"]);
    return o(m, p, h);
  }).withConfig({
    displayName: "StyledTypography",
    componentId: "VDS__sc-15sxhse-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  font-family: ", ";\n  letter-spacing: ", ";\n  color: ", ";\n  margin: 0;\n  text-decoration: none;\n"])), function (_ref) {
    var t = _ref.fontSize;
    return e(t);
  }, function (_ref2) {
    var t = _ref2.fontWeight;
    return t;
  }, function (_ref3) {
    var t = _ref3.lineheight;
    return e(t);
  }, function (_ref4) {
    var t = _ref4.fontFamily;
    return "".concat(t, ", Helvetica, Arial, Sans-serif");
  }, function (_ref5) {
    var t = _ref5.letterSpacing;
    return t ? e(t) : "normal";
  }, function (_ref6) {
    var t = _ref6.color;
    return t;
  }),
  c = function c(t) {
    var o, n;
    var e = t.primitive,
      c = t.children;
    return r.checkFontLoaded && !r.checkFontLoaded() && (null === (o = null == r ? void 0 : r.loadFonts) || void 0 === o || o.call(r), null === (n = null == r ? void 0 : r.setFontLoaded) || void 0 === n || n.call(r, !0)), i(l, Object.assign({}, t, {
      primitive: e,
      children: c
    }));
  };
c.defaultProps = {
  children: null,
  primitive: "p"
};
export { c as default };